export default "__VITE_ASSET__743599a8__"